/* eslint-disable react/no-array-index-key */
import React, { useEffect } from "react"
import { useFormikContext } from "formik"
import { observer } from "mobx-react-lite"
import clsx from "clsx"

import ErrorChip from "@components/ui/ErrorChip/ErrorChip"
import TextInput from "@components/ui/TextInput/TextInput"
import Icon from "@components/ui/Icon/Icon"
import Button from "@components/ui/Button/Button"

import { SitemapFormType } from "./types"

import styles from "./ConnectWebsite.module.sass"

export interface SitemapFormProps {
  className?: string
}

export const SitemapForm: React.FC<SitemapFormProps> = observer(
  ({ className }) => {
    const formik = useFormikContext<SitemapFormType>()

    useEffect(() => {
      formik.resetForm({
        values: { name: formik.values.name, sitemapUrls: [""] },
      })
    }, [])

    const handleAdd = () => {
      const subpages = formik.values.sitemapUrls ?? []
      formik.setValues({
        ...formik.values,
        sitemapUrls: [...subpages, ""],
      })
    }

    const handleRemove = (idx: number) => {
      const newList =
        formik.values.sitemapUrls?.filter((_, index) => idx !== index) ?? []
      formik.setValues({ ...formik.values, sitemapUrls: newList })
    }

    if (!formik.values.sitemapUrls) return null

    const canDelete = formik.values.sitemapUrls.length > 1

    return (
      <div className={clsx(styles.form, className)}>
        <div className={styles.list}>
          {formik.values.sitemapUrls?.map((item, idx) => {
            const isTouched = !!(formik.touched.sitemapUrls as any)?.[idx]
            const error = formik.errors.sitemapUrls?.[idx]
            const hasError = isTouched && !!error

            return (
              <TextInput
                id={`${idx}`}
                className={styles.input}
                placeholder="Paste website subpage link"
                value={item}
                name={`sitemapUrls[${idx}]`}
                withError={hasError}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                key={idx}
                after={
                  ((isTouched && !!error) || canDelete) && (
                    <div className={styles.after}>
                      {isTouched && !!error ? (
                        <ErrorChip messagePlacement="left" message={error} />
                      ) : null}
                      {canDelete ? (
                        <Icon
                          name="cross"
                          className={styles.closeBtn}
                          onClick={() => handleRemove(idx)}
                        />
                      ) : null}
                    </div>
                  )
                }
              />
            )
          })}
        </div>

        <Button
          size="medium"
          variant="outlined"
          className={styles.addButton}
          before={<Icon name="plus" />}
          onClick={handleAdd}
        >
          Add Link
        </Button>
      </div>
    )
  }
)

export default SitemapForm
